<template>
  <div>
    <div class="breadcrumb_section bg_gray page-title-mini">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="page-title">
              <h1>{{ accountPackage.name }}</h1>
            </div>
          </div>
          <div class="col-md-6">
            <ol class="breadcrumb justify-content-md-end">
              <li class="breadcrumb-item"><a :href="route('home',{ domain : website.domain } )">Home</a>
              </li>
              <li class="breadcrumb-item active">{{ accountPackage.name }}</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="container pt-5" v-if="(this.accountPackage.shop_extras.length >0) && this.accountPackage.shop_extras[0].value">
      <div class="card bg_light_blue" v-if="this.accountPackage.shop_extras[0].value">
          <div class="card-body">
            <p style="margin: 0;" class="card-title"><b>Thông tin</b></p>
            <div :style="{height: (expand_descript == true ? 'auto' : '100px')}" class="overflow-hidden" v-html="this.accountPackage.shop_extras[0].value"></div>
          </div>
          <div class="card-footer text-center" style="cursor: pointer;">
            <span class="text-primary h5" style="cursor: pointer;" v-if="!expand_descript" @click="expand_descript = true">Xem thêm <i class="linearicons-chevron-down"></i></span>
            <span class="text-primary h5" style="cursor: pointer;" v-if="expand_descript" @click="expand_descript = false">Thu gọn <i class="linearicons-chevron-up"></i></span>
          </div>
      </div>
    </div>
    <div class="container pt-5" v-else-if="this.accountPackage.show_noti === 'on'">
      <div class="row rounded bg_light_blue p-3">
        <h3>Thông tin: </h3>
        <div v-html="accountPackage.notify"></div>
      </div>
    </div>
    <div class="main_content">
      <div class="section">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="row align-items-center mb-4 pb-1">
                <div class="col-12">
                  <div class="row  hidden-xs hidden-sm" style="margin-bottom: 15px">
                    <div class="col-md-12 m-l-10 m-r-10 form-inline  m-b-10">
                      <div class="col-md-3 col-sm-4 field-search">
                        <div class="input-group ">
                          <input type="text" class="form-control " placeholder="Mã số acc" v-model="id_selected">
                        </div>
                      </div>
                      <!-- <div class="col-md-3 col-sm-4 field-search" v-if="!_.isEmpty(genshinData)">
                        <div class="input-group ">
                          <multiselect v-model="champ_selected"
                                       :options="genshinData.CHAMPIONS"
                                       :multiple="true"
                                       :close-on-select="false"
                                       :clear-on-select="false"
                                       :preserve-search="true"
                                       :hide-selected="true"
                                       selectLabel="Chọn"
                                       deselectLabel="Xoá"
                                       placeholder="Chọn Tướng">
                            <template slot="selection" slot-scope="{ values, search, isOpen }">
                              <span class="multiselect__single"
                                    v-if="values.length && !isOpen">
                                Đã chọn {{ values.length }} Tướng
                              </span>
                            </template>
                          </multiselect>
                        </div>
                      </div>
                      <div class="col-md-3 col-sm-4 field-search" v-if="!_.isEmpty(genshinData)">
                        <div class="input-group ">
                          <multiselect v-model="weapons_selected"
                                       :options="genshinData.WEAPONS"
                                       :multiple="true"
                                       :close-on-select="false"
                                       :clear-on-select="false"
                                       :preserve-search="true"
                                       :hide-selected="true"
                                       selectLabel="Chọn"
                                       deselectLabel="Xoá"
                                       placeholder="Chọn vũ khí">
                            <template slot="selection" slot-scope="{ values, search, isOpen }">
                              <span class="multiselect__single"
                                    v-if="values.length && !isOpen">
                                Đã chọn {{ values.length }} vũ khí
                              </span>
                              </template>
                          </multiselect>
                        </div>
                      </div> -->
                      <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12 field-search">
                          <div class="input-group ">
                            <select v-model="price_selected" class="form-control">
                              <option v-for="option in price_options" :value="option.value" :key="option.value">
                                {{ option.text }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-3 col-sm-4 col-xs-12 field-search"  v-if="accountPackage.category.type === categoryTypes.MOBA">
                          <div class="input-group ">
                            <select v-model="rank_selected" class="form-control"
                                    v-if="accountPackage.category.type === categoryTypes.FPS">
                              <option v-for="option in rank_fps" :value="option.slug" :key="option.id">
                                {{ option.fps }}
                              </option>
                            </select>
                            <select v-model="rank_selected" class="form-control"
                                    v-if="accountPackage.category.type === categoryTypes.MOBA">
                              <option v-for="option in rank_moba" :value="option.slug" :key="option.id">
                                {{ option.moba }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <span v-for="(configData, config) in accountPackage.category.account_normal_configs"
                              :key="config">
                            <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12 field-search"
                                 v-if="config==='server' && configData.filter" >
                                <select class="form-control" v-model="server_selected">
                                    <option value="0">Lọc theo server</option>
                                    <option v-for="(option, id) in accountServers[accountPackage.category_id]" :value="id" :key="id">
                                        {{option}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12 field-search"
                                 v-if="config==='type' && configData.filter && accountPackage.id !== 12">
                                <select class="form-control" v-model="type_selected">
                                    <option value="0" v-if="accountPackage.category_id === 5">Lọc theo hành tinh</option>
                                    <option value="0" v-else>Lọc theo loại account</option>
                                    <option v-for="(option, id) in accountTypes[accountPackage.category_id]" :value="id" :key="id">
                                        {{option}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-4 col-xs-12 field-search"
                                 v-if="config==='equipment' && configData.filter
                                    && (accountPackage.category_id !== accountCategories.NRO || accountPackage.id === 12)">
                                <select class="form-control" v-model="equipment_selected">
                                    <option value="0">Lọc theo trang bị</option>
                                    <option v-for="(option, id) in accountEquipment[accountPackage.category_id]" :value="id" :key="id">
                                        {{option}}
                                    </option>
                                </select>
                            </div>
                        </span>
                        <!-- <div class="col-md-2 col-sm-4 col-xs-12 field-search" v-if="!_.isEmpty(genshinData)">
                          <div class="input-group">
                            <select v-model="ar_genshin_selected" class="form-control">
                              <option v-for="option in ar_genshin_options" :value="option.value" :key="option.value">
                                {{ option.text }}
                              </option>
                            </select>
                          </div>
                        </div> -->
                        <div class="col-md-3 col-sm-4 no-radius">
                          <div class="d-flex">
                            <button type="button" class="btn btn-sm btn-success btn-custom-filter" @click="handlePaginate">Tìm kiếm</button>
                            <button type="button" class="btn btn-sm btn-warning btn-custom-filter" @click="clearFilter">Xoá lọc</button>
                          </div>

                        </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row shop_container" v-if="accountDataSet.data.length > 0">
                <div class="col-lg-3 col-md-4 col-6 grid_item" v-for="account in accountDataSet.data"
                     :key="account.id"
                     :id="account.id">
                  <div class="product_box  text-center">
                    <span class="pl_flash">Acc #{{ account.id }}</span>
                    <span v-if="account.is_fake_sale === 'on'" class="pr_flash">Nick Siêu Sale</span>
                    <div class="product_img">
                      <a :href="route('fe_viewacc', { domain: website.domain, id: account.id} )"
                         target="_blank">
                        <img class="card-img-top" :src="account.thumbnail" :alt="'Account ' + accountPackage.name + ' #' + account.id"
                             :height="152" :width="253"/>
                      </a>
                      <div class="product_action_box">
                        <ul class="list_none pr_action_btn">
                          <li>
                            <button
                              type="button"
                              class="updateCashButton btn btn-buy-now btn-radius btn-sm"
                              @click="buyAcc(account)">Mua Ngay
                            </button>
                          </li>
                          <li v-if="account.price >= accountPackage.deposit_price_above">
                            <button
                              type="button"
                              class="btn btn-primary btn-radius btn-sm"
                              @click="depositAcc(account)">Trả góp ngay
                            </button>
                          </li>
                        </ul>
                      </div>
                      <div class="account-desc" v-html="account.content"></div>
                    </div>
                    <div class="product_info">
                      <h6 class="product_title" v-if="account.category_id !== accountCategories.NRO">
                        <a :href="route('fe_viewacc', { domain: website.domain, id: account.id} )"
                           target="_blank">
                          <span class="col">Rank: <b
                              v-if="accountPackage.category.type === categoryTypes.MOBA">{{
                              account.rank.moba
                            }}</b>
                            <b v-else>{{ account.rank.fps }}</b></span>
                        </a>
                      </h6>
                      <div class="row">
                        <span class="col-6" style="padding: 0; font-size: 15px"
                              v-if="account.category.account_normal_configs.type && account.category.account_normal_configs.type.client_show">
                          Hành tinh: <b>{{accountTypes[accountPackage.category_id][account.type]}}</b>
                        </span>
                        <span class="col-6" style="padding: 0; font-size: 15px"
                              v-if="account.category.account_normal_configs.server && account.category.account_normal_configs.server.client_show">
                          Server: <b>{{accountServers[accountPackage.category_id][account.server]}}</b>
                        </span>
                      </div>

                      <span class="col" style="font-size: 15px"
                            v-if="account.category_id === accountCategories.NRO && packageShowVirtualRegistration.includes(account.account_package_id)">
                        Đăng ký: <b>Ảo</b>
                      </span>
                      <span class="col" v-else-if="account.category_id !== accountCategories.NRO">
                        Đăng ký: {{ getLoginType(account.login_type) }}
                      </span>

                      <div class="product_price text-center">
                            <span
                                class="price text-success">ATM {{
                                Helper.formatMoney(account.atm_price)
                              }}<sup>đ</sup> </span><br>
                        <span class="price"> Card {{
                            Helper.formatMoney(account.price)
                          }}<sup>đ</sup></span>
                        <del v-if="account.old_price > account.price">
                          {{ Helper.formatMoney(account.old_price) }}<sup>đ</sup></del>
                        <div class="on_sale" v-if="account.promo > 0">
                          <span>Giảm {{ account.promo }}% </span>
                        </div>
                      </div>
                      <div class="pr_desc">
                        <div class="row row-cols-2"
                             v-if="accountPackage.category.type === categoryTypes.MOBA">
                          <p class="col">Tướng: <b>{{ account.owner_champions }}</b></p>
                          <p class="col">Skin: <b>{{ account.owner_skins }}</b></p>
                        </div>
                        <div class="row row-cols-2"
                             v-if="accountPackage.category.type === categoryTypes.FPS && account.category_id !== accountCategories.DOT_KICH">
                          <p class="col">Súng {{ account.owner_guns }}</p>
                          <p class="col">Skin {{ account.owner_skins }}</p>
                        </div>
                      </div>
                      <div class="add-to-cart">
                        <a class="btn btn-fill-out btn-radius"
                           :href="route('fe_viewacc', { domain: website.domain, id: account.id} )">Chi tiết</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="pagination mt-3 justify-content-center pagination_style1">
                    <b-pagination
                        v-model="accountDataSet.current_page"
                        :total-rows="accountDataSet.total"
                        :per-page="accountDataSet.per_page"
                        first-number
                        last-number
                        page-class="mr-1"
                        next-class="mr-1"
                        prev-class="mr-1"
                        last-class="mr-1"
                        align="center"
                        @change="handlePaginate"
                    >
                      <template v-slot:page="{ page, active }" class="page-link">
                        <b v-if="active">{{ page }}</b>
                        <i v-else>{{ page }}</i>
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <buy-account-modal-v3
        :account="this.account"
        :user="this.user"
        :website="this.website"
        :current-wallet="currentWallet"
        @reload="handlePaginate(1)"
        v-if="user"
    >
    </buy-account-modal-v3>

    <deposit-account-modal-v3
        :account="this.account"
        :user="this.user"
        :website="this.website"
        :current-wallet="currentWallet"
        @reload="handlePaginate(1)"
        v-if="user"
    >
    </deposit-account-modal-v3>
  </div>
</template>
<script>
import BuyAccountModalV3 from "./BuyAccountModalV3.vue";
import DepositAccountModalV3 from "./DepositAccountModalV3.vue";
export default {
  components: {BuyAccountModalV3, DepositAccountModalV3},
  props: {
    user: {
      Type: Object,
      default() {
        return {};
      }
    },
    currentWallet: {
      Type: Array,
      default() {
        return [];
      }
    },
    accountPackage: {
      Type: Object,
      default() {
        return {};
      }
    },
    categoryTypes: {
      Type: Object,
      default() {
        return {};
      }
    },
    loginTypes: {
      Type: Object,
      default() {
        return {};
      }
    },
    ranks: {
      Type: Object,
      default() {
        return {};
      }
    },
    accounts: {
      Type: Object,
      data() {
        return {}
      }
    },
    genshinData: {
      Type: Object,
      data() {
        return {}
      }
    },
    accountTypes: {
        Type: Object,
        default() {
            return {};
        }
    },
    accountServers: {
        Type: Object,
        default() {
            return {};
        }
    },
    accountEquipment: {
      Type: Object,
      default() {
        return {};
      }
    },
    website: {
      Type: Object,
      data() {
        return {}
      }
    }
  },
  watch: {
    skin_selected: function () {
      this.handlePaginate(1)
    }
  },
  data() {
    return {
      packageShowVirtualRegistration: [10, 11],
      accountCategories: {
          'NRO': 5,
          'DOT_KICH': 3,
      },
      accountDataSet: this._.clone(this.accounts),
      rank_fps: {},
      rank_moba: {},
      price_selected: 'all',
      skin_selected:  [],
      champ_selected: [],
      weapons_selected: [],
      rank_selected: 'all',
      server_selected: 0,
      type_selected: 0,
      equipment_selected: 0,
      login_type: 'all',
      price_options: [
          {value: 'all', text: 'Lọc theo giá (Tất cả)'},
          {value: '0-50000', text: 'Từ 50k trở xuống'},
          {value: '50000-100000', text: 'Từ 50k đến 100k'},
          {value: '100000-300000', text: 'Từ 100k đến 300k'},
          {value: '300000-500000', text: 'Từ 300k đến 500k'},
          {value: '500000-700000', text: 'Từ 500k đến 700k'},
          {value: '700000-1000000', text: 'Từ 700k đến 1 Triệu'},
          {value: '1000000-2000000', text: 'Từ 1 Triệu đến 2 Triệu'},
          {value: '2000000-5000000', text: 'Từ 2 Triệu đến 5 Triệu'},
          {value: '5000000-10000000', text: 'Từ 5 Triệu đến 10 Triệu'},
          {value: '10000000-100000000', text: 'Từ 10 Triệu trở lên'},
      ],
      ar_genshin_options: [
        {value: 'all', text: 'Lọc AR (Tất cả)'},
        {value: '0-20', text: 'Từ 20 trở xuống'},
        {value: '20-40', text: 'Từ 20 đến 40'},
        {value: '40-300000', text: 'Từ 40 trở lên'},
      ],
      ar_genshin_selected: 'all',
      skinList: [],
      id_selected: '',
      account: {},
      expand_descript: false,
    }
  },
  mounted() {
    this.initSkin();
    this.ranks.unshift({
      fps: "Lọc theo rank (tất cả)",
      moba: "Lọc theo rank (tất cả)",
      slug: 'all',
    });


    this.rank_moba = this._.filter(this.ranks, function (item) {
      return item.moba !== null
    });
    this.rank_fps = this._.filter(this.ranks, function (item) {
      return item.fps !== null
    });

    this.loginTypes =  Object.assign(this.loginTypes, { "all": "Tất Cả" });

  },
  methods: {
    getLoginType(value){
      return this.loginTypes[value];
    },
    clearFilter() {
      this.skin_selected = [];
      this.weapons_selected = [];
      this.champ_selected = [];
      this.price_selected = 'all';
      this.id_selected = '';
      this.login_type = 'all',
      this.rank_selected = 'all',
      this.server_selected = 0;
      this.type_selected = 0;
      this.equipment_selected = 0;
      this.handlePaginate(1);
    },
    buyAcc(account) {
      if (!this.user){
        // window.open(this.route('login', {domain: this.website.domain}))
        window.location.href = "/login?domain=" + this.website.domain;
      }
      this.account = account;
      this.$bvModal.show('buyAccModal');
    },
    depositAcc(account) {
      if (!this.user){
        window.location.href = "/login?domain=" + this.website.domain;
      }
      this.account = account;
      this.$bvModal.show('depositAccModal');
    },
    async initSkin() {
      const uri = this.route('home', {domain: this.website.domain}) + 'assets/js/skins.json';
      let response = await this.Request.get(uri);

      this.skinList = this._.clone(response.data);
    },
    async handlePaginate(page) {
      let params = {
        price: this.price_selected,
        rank: this.rank_selected,
        login_type: this.login_type,
        skin: this.skin_selected,
        champions: this.champ_selected,
        weapons: this.weapons_selected,
        runes: this.ar_genshin_selected,
        domain: this.website.domain,
        account_id: this.id_selected,
        server_id: this.server_selected,
        type: this.type_selected,
        equipment: this.equipment_selected,
        package: this.accountPackage.slug
      };

      if (page > 1) {
        params.page = page;
      }
      const uri = this.route('fe.package', params);
      let response = await this.Request.get(uri);
      this.accountDataSet = this._.clone(response.data);

      this.$scrollTo('#head_page', 200);
    }
  }
}
</script>

<style scoped>
.ribbon:nth-child(even) {
  margin-right: 4%;
}

@media (max-width: 500px) {
  .ribbon {
    width: 100%;
  }

  .ribbon:nth-child(even) {
    margin-right: 0%;
  }
}

.ribbon4 {
  position: absolute;
  padding: 8px 10px;
  background: #dc3545;
  box-shadow: -1px 2px 3px rgba(0, 0, 0, .3);
}

.ribbon4:before, .ribbon4:after {
  content: "";
  position: absolute;
}

.ribbon4:before {
  width: 7px;
  height: 100%;
  top: 0;
  left: -6.5px;
  padding: 0 0 7px;
  background: inherit;
  border-radius: 5px 0 0 5px;
}

.ribbon4:after {
  width: 5px;
  height: 5px;
  bottom: -5px;
  left: -4.5px;
  background: lightblue;
  border-radius: 5px 0 0 5px;
}
.account-desc {
    position: absolute;
    bottom: 0;
    background: #1f5b85;
    color: white;
    width: 100%;
    right: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
::v-deep .account-desc p {
    color: white;
    line-height: unset;
    margin-bottom: 0;
    padding: 0 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
